// 🔧 content_seeder.js
// ✅ Purpose: Content Seeder for the LGV Seed Engine
// ✅ Features:
// - Writes realistic public event content into /events/{eventId}/settings/voting
// - Uses the same fields managed by settings_content.js
// - Supports Event Home without demo-specific schema
// - Future-ready for AI-generated event content
// - Fully block-commented for clarity and future devs

import {
  doc,
  setDoc,
  Timestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";
import { logger } from "../../../utils/logger";

import { buildContentSettings } from "../../templates/content_defaults";

export const seedContent = async ({
  eventResult,
  industryTemplate,
} = {}) => {
  if (!eventResult?.eventId) {
    throw new Error("Content Seeder requires an event.");
  }

  const contentSettings = buildContentSettings({
    eventName: eventResult.eventName,
    industryTemplate,
    eventEnd: eventResult.eventDoc?.endDate,
  });

  await setDoc(
    doc(
      db,
      "events",
      eventResult.eventId,
      "settings",
      "voting"
    ),
    {
      ...contentSettings,

      lastSaved: Timestamp.now(),

      seededBy: "seed_engine",

      seededContent: true,
    },
    { merge: true }
  );

  logger.log("📝 Content Seeder completed.", {
    value: {
      eventId: eventResult.eventId,
    },
  });

  return {
    seeder: "content_seeder",

    ready: true,

    createdCount: 1,

    contentSettings,

    message:
      "Content Seeder created public event content settings.",
  };
};

export const seedContentShell = async ({
  eventResult,
  industryTemplate,
} = {}) => {
  if (!eventResult?.eventId) {
    return {
      seeder: "content_seeder",

      ready: false,

      createdCount: 0,

      message:
        "Content Seeder requires an event.",
    };
  }

  return seedContent({
    eventResult,
    industryTemplate,
  });
};
